import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "monitoring-transfusi"
})
class MonitoringTransfusiModule extends VuexModule {
  items: any[] = [];
  currentItem: any = null;
  loading = false;

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await MonitoringTransfusiSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }

    this.SET_LOADING(false);
  }

  @Action async getDetail(id: number) {
    this.SET_LOADING(true);

    try {
      const dt = await MonitoringTransfusiSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
  }
}

export const storeMonitoringTransfusi = getModule(
  MonitoringTransfusiModule
);
